'use strict';

module.exports = [
// type
require('./BigNumber'),

// construction function
require('./function/bignumber')];


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/type/bignumber/index.js
// module id = M1lu
// module chunks = 0